import React, { useContext, useEffect, useState } from "react";
import {QuotationContext} from "../../../../contexts/QuotationContext";
import {QuotationCardContext} from "../../../../contexts/QuotationCardContext";
import {MtplQuotation} from "../../../../model/quotation";
import {Formik} from "formik";
import {ProcessingContext} from "../../../../contexts/ProcessingContext";
import * as log from "../../../../utils/log";
import {LogFunctionalModule} from "../../../../utils/log";
import {getSnippetByName} from "../../../../api/snippetApiClient";
import {WIDGET_DURATION, WidgetTooltip} from "../../../../App";
import {ChatWidget} from "../../../../model/chatWidget";
import "./GreenPersonalInfoForm.scss";
import "../GreenStepsStyles.scss";
import { useHotjar } from "../../../../utils/hooks/useHotjar";
import { Form } from "./Form";
import {fieldsName} from "./consts";
import { EventTypeKey, useTabCloseTracking } from "../../forms/hooks/useTabCloseTracking";

interface Props {
    onFormSubmit: (quotation: MtplQuotation) => void
    backStepHandler: (quotation: MtplQuotation) => void
}

export const GreenPersonalInfoForm = ({onFormSubmit, backStepHandler}: Props) => {
    const {
        quotation,
        agreeOption1,
        agreeOption2,
        agreeInformOption,
        type
    } = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const {setProcessingOpen} = useContext(ProcessingContext);
    const {
        loadFromServer,
        validateFields
    } = useContext(QuotationCardContext);

    const { trackHotjar } = useHotjar()

    const [email, setEmail] = useState<string | undefined>(undefined);

    useEffect(() => {
        setEmail(quotation?.mtplContract?.primaryInsured?.email);
    }, [quotation]);

    useTabCloseTracking(email, EventTypeKey.AbandonedGreencard);

    useEffect(() => {
        loadFromServer(Object.values(fieldsName))
    }, [])

    useEffect(() => {
        let event = 'green_card_conditions_extra';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});
        trackHotjar("car-data", type)
    }, []);

    React.useEffect(() => {
        let timout: NodeJS.Timeout
        getSnippetByName(ChatWidget.TEMPLATE_HINT_FILL_INFO).then(res => {
            timout = setTimeout(() => {
                WidgetTooltip?.open(res.text, WIDGET_DURATION)
            }, 1000)
        })

        return () => {
            clearTimeout(timout)
            WidgetTooltip?.close()
        }
    }, [])

    quotation.mtplContract.primaryInsured.resident = quotation.mtplContract.primaryInsured.resident ? quotation.mtplContract.primaryInsured.resident : false;


    const handleSubmitForm = (values) => {
        setProcessingOpen(true);
        validateFields(values.quotation).then(res => {
            if (res) {
                log.sendLog(new Date(), LogFunctionalModule.STORE_GREEN_CARD, 'INFO',
                    "PERSONAL_INFO_FORM_NEXT_HANDLER",
                    [{quotation, values}]);
                onFormSubmit(values.quotation);
            } else {
                setProcessingOpen(false);
            }
        });
    }

    const onBack = (formProps) => {
        log.sendLog(new Date(), LogFunctionalModule.STORE_GREEN_CARD, 'INFO',
            "PERSONAL_INFO_FORM_BACK_HANDLER",
            [{quotation: quotation, formProps: formProps}], '')
        backStepHandler(formProps.initialValues.quotation);
    }

    return (
        <div className='personal-info-container'>
            <Formik
                initialValues={{
                    agree1: agreeOption1,
                    agree2: agreeOption2,
                    agreeInform: agreeInformOption,
                    quotation
                }}
                onSubmit={handleSubmitForm}
            >
                <Form onBack={onBack} />
            </Formik>
        </div>
    )
};
